import React from 'react';

function Footer() {
    const currentYear = new Date().getFullYear(); // Получаем текущий год

    return (
        <footer>
            <div>
                <span>&copy; Gallery Mart {currentYear}</span>{' '}
                <a href="/privacy-policy" className="link">Политика конфиденциальности</a>
            </div>
        </footer>
    );
}

export default Footer;